import MDPagination from "../components/MDPagination";

function MyMDPagination(props: any) {
  return <MDPagination {...props} />;
}

export default MyMDPagination;
